module.exports = __webpack_public_path__ + "static/media/Style4.d10e74c9.PNG";